<mat-dialog-content>

    <div class="flex-row flex-space-between w-100 pt-10">
        <div class="flex-row gap-15 p-10">
            <mat-card-title>{{ data?.title }}</mat-card-title>
        </div>
        <div class="closeBtn">
            <button class="mat-dialog-close" mat-dialog-close mat-icon-button matTooltip="Close modal"
                    tabindex="-1">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
    <mat-card-content>
        <p>
            {{ data?.content }}
        </p>
    </mat-card-content>
</mat-dialog-content>
